/* Copyright (c) 2021-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import * as React from "react";

type Props = {
  condition: boolean;
  wrap: (children: JSX.Element) => JSX.Element;
  children: JSX.Element;
};

export function ConditionalWrap({ condition, children, wrap }: Props) {
  return condition ? React.cloneElement(wrap(children)) : children;
}
